import React from "react";
import { motion } from "framer-motion";
import { CheckCircle, TrendingUp, BarChart3 } from "lucide-react";

export default function VisionSection() {
  const visionPillars = [
    {
      icon: <CheckCircle size={40} />,
      title: "Smarter Execution",
      description: "We help biotech teams focus, align, and deliver at every phase of development."
    },
    {
      icon: <BarChart3 size={40} />,
      title: "Informed Decisions",
      description: "Dashboards and tools built for clarity, compliance, and confident action."
    },
    {
      icon: <TrendingUp size={40} />,
      title: "Faster Progress",
      description: "Our solutions streamline operations and accelerate the path to patients."
    }
  ];

  return (
    <section id="vision" className="bg-beige py-24 px-6 text-center">
      <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.2 }}>
        <h2 className="text-5xl font-bold text-dark-teal">Our Vision</h2>
        <p className="text-dark-brown mt-6 text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
          We build systems and deliver insights that empower drug discovery and development operations teams to move faster, work smarter, and stay in control.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-20 max-w-6xl mx-auto">
        {visionPillars.map((pillar, index) => (
          <div key={index} className="flex flex-col items-center bg-white p-8 rounded-xl shadow-md text-center">
            <div className="text-teal-green">{pillar.icon}</div>
            <h3 className="text-2xl font-bold mt-4 text-dark-teal">{pillar.title}</h3>
            <p className="text-dark-brown mt-3 text-xl">{pillar.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}